export function isLocalhost() {
  return (
    typeof window !== 'undefined' && window.location.hostname === 'localhost'
  );
}
